import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import axios from 'axios';

interface CashReportProps {
  tableData: any[];
  pharmacyNum: string | null;
  startDate: string;
  endDate: string;
  selectedMonth?: string;
  employeeName: string;
  disabled?: boolean;
}

const CashReport: React.FC<CashReportProps> = ({
  tableData,
  pharmacyNum,
  startDate,
  endDate,
  selectedMonth,
  employeeName,
  disabled = false
}) => {

  const getMonthName = (): string => {
    const months = [
      'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
      'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
    ];
    if (selectedMonth) {
      const monthIndex = parseInt(selectedMonth.split('-')[1]) - 1;
      return months[monthIndex];
    }
    return '';
  };

  const getYear = (): string => {
    if (selectedMonth) {
      return selectedMonth.split('-')[0];
    }
    return '';
  };

  const [hasReports, setHasReports] = useState<boolean>(true);
  const [hasPos, setHasPos] = useState<boolean>(true);

useEffect(() => {
    const fetchPharmacyNum = async () => {
      const username = localStorage.getItem('username');
      if (username) {
        try {
          const response = await axios.get('https://tbl.zerdegroup.kz/api/user-info', {
            params: { username }
          });
          if (response.data.success) {
            setHasReports(response.data.hasReports);
            setHasPos(response.data.pos === 1);
          }
        } catch (err) {
          console.error('Ошибка при получении номера аптеки:', err);
        }
      }
    };
    fetchPharmacyNum();
  }, []);

  const generateReport = async () => {
    try {
      const response = await fetch('/templates/cash_report_template.docx');
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();

      const rows = tableData.map((row, index) => ({
        num: index + 1,
        date: row.date,
        cash_balance_start_of_day: row.cash_balance_start_of_day || 0,
        cash: row.cash || 0,
        cash_collection: row.cash_collection || 0,
        funds_transfer_to_office: row.funds_transfer_to_office || 0,
        other_expenses: row.other_expenses || 0,
        cash_balance_end_of_day: row.cash_balance_end_of_day || 0
      }));

      const totals = rows.reduce((acc, row) => ({
        totalCash_balance_start_of_day: acc.totalCash_balance_start_of_day + (parseFloat(row.cash_balance_start_of_day) || 0),
        totalCash: acc.totalCash + (parseFloat(row.cash) || 0),
        totalCash_collection: acc.totalCash_collection + (parseFloat(row.cash_collection) || 0),
        totalCashTransfer: acc.totalCashTransfer + (parseFloat(row.funds_transfer_to_office) || 0),
        totalOtherExpense: acc.totalOtherExpense + (parseFloat(row.other_expenses) || 0),
        totalCash_balance_end_of_day: acc.totalCash_balance_end_of_day + (parseFloat(row.cash_balance_end_of_day) || 0)
      }), {
        totalCash_balance_start_of_day: 0,
        totalCash: 0,
        totalCash_collection: 0,
        totalCashTransfer: 0,
        totalOtherExpense: 0,
        totalCash_balance_end_of_day: 0
      });

      const data = {
        pharmacyNum: pharmacyNum ? pharmacyNum.toString() : '',
        currentMonth: getMonthName(),
        currentYear: getYear(),
        period: `${startDate} - ${endDate}`,
        employeeName: employeeName,
        rows,
        ...totals
      };

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true
      });

      doc.render(data);

      const out = doc.getZip().generate({
        type: 'blob',
        mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });

      const fileName = `Отчет о движении наличных денежных средств за ${selectedMonth || 'месяц'}.docx`;
      saveAs(out, fileName);

    } catch (error) {
      console.error('Ошибка при генерации отчета:', error);
    }
  };

  return (
    <>
      <Button
        color='secondary'
        variant="contained"
        onClick={generateReport}
        disabled={!hasReports || !tableData.length || !employeeName || !hasPos || disabled}
      >
        Касса
      </Button>
    </>
  );
};

export default CashReport;